import STORAGETYPE from "./storage_types";

const initialState = {
  map_details: {},
  restaurant_details: {},
  point_of_contact: {},
  chain_setting: {},
  restaurant_type: {},
  payment_type: {},
  dress_code: {},
  pets_allowed: {},
  located_inside: {},
  point_of_sale: {},
  health_and_senitation: {},
  parking_type: {},
  accessibility_type: {},
  other_features_type: {},
  services_offered_type: {},
  cuisine_features_type: {},
  food_type: {},
  cuisine_offered_type: {},
  business_hours: {},
  kyc_details: {},
  subscription_details: {},
  flag: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case STORAGETYPE.MAP_DETAILS:
      return {
        ...state,
        map_details: action.payload,
      };
    case STORAGETYPE.RESTAURANT_DETAILS:
      return {
        ...state,
        restaurant_details: action.payload,
      };
    case STORAGETYPE.POINT_OF_CONTACT:
      return {
        ...state,
        point_of_contact: action.payload,
      };
    case STORAGETYPE.CHAIN_SETTING:
      return {
        ...state,
        chain_setting: action.payload,
      };
    case STORAGETYPE.RESTAURANT_TYPE:
      return {
        ...state,
        restaurant_type: action.payload,
      };
    case STORAGETYPE.PAYMENT_TYPE:
      return {
        ...state,
        payment_type: action.payload,
      };
    case STORAGETYPE.DRESS_CODE:
      return {
        ...state,
        dress_code: action.payload,
      };
    case STORAGETYPE.PETS_ALLOWED:
      return {
        ...state,
        pets_allowed: action.payload,
      };
    case STORAGETYPE.LOCATED_INSIDE:
      return {
        ...state,
        located_inside: action.payload,
      };
    case STORAGETYPE.POINT_OF_SALE:
      return {
        ...state,
        point_of_sale: action.payload,
      };
    case STORAGETYPE.HEALTH_AND_SENITATION:
      return {
        ...state,
        health_and_senitation: action.payload,
      };
    case STORAGETYPE.PARKING_TYPE:
      return {
        ...state,
        parking_type: action.payload,
      };
    case STORAGETYPE.ACCESSIBILITY:
      return {
        ...state,
        accessibility_type: action.payload,
      };
    case STORAGETYPE.OTHER_FEATURES:
      return {
        ...state,
        other_features_type: action.payload,
      };
    case STORAGETYPE.SERVICES_OFFERED:
      return {
        ...state,
        services_offered_type: action.payload,
      };
    case STORAGETYPE.CUISINE_FEATURES:
      return {
        ...state,
        cuisine_features_type: action.payload,
      };
    case STORAGETYPE.FOOD_TYPE:
      return {
        ...state,
        food_type: action.payload,
      };
    case STORAGETYPE.CUISINE_OFFERED:
      return {
        ...state,
        cuisine_offered_type: action.payload,
      };
    case STORAGETYPE.BUSINESS_HOURS:
      return {
        ...state,
        business_hours: action.payload,
      };
    case STORAGETYPE.KYC_DETAILS:
      return {
        ...state,
        kyc_details: action.payload,
      };
    case STORAGETYPE.SUBSCRIPTION_DETAILS:
      return {
        ...state,
        subscription_details: action.payload,
      };
    case STORAGETYPE.FETCH_FLAG:
      return {
        ...state,
        flag: action.payload,
      };
    default:
      return state;
  }
}
